import React from 'react';
import { Shield } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-dark text-ice/60 py-12 px-4 border-t border-white/10" data-id="element-80">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-81">
        <Shield className="w-8 h-8 text-gold/50 mb-6" data-id="element-82" />
        <p className="font-heading text-xl text-ice/80 mb-4" data-id="element-83">Escudo de Fe</p>
        <p className="font-body text-sm max-w-md mx-auto" data-id="element-84">
          Una guía espiritual para la protección y tranquilidad de las familias
          mexicanas.
        </p>
      </div>
    </footer>;
}